module.exports = new __parcel__URL__("hontar_x2.c5676673.webp").toString();